// ============================================
// APPLICATION - Storefront Hooks (público)
// ============================================

import { useQuery, useMutation } from '@tanstack/react-query';
import { storefrontRepository, type CrearPedidoPublicoPayload } from '../../infrastructure/http/storefront.repository';

export const useStorefront = (almacenId: number) => {
  return useQuery({
    queryKey: ['storefront', almacenId],
    queryFn: () => storefrontRepository.obtenerStorefront(almacenId),
    staleTime: 5 * 60 * 1000,
    retry: 2,
    enabled: !!almacenId,
  });
};

export const useCrearPedidoPublico = (almacenId: number) => {
  return useMutation({
    mutationFn: (payload: CrearPedidoPublicoPayload) =>
      storefrontRepository.crearPedido(almacenId, payload),
  });
};
